import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ConfigChangeRequest } from './config-change-request.model';

@Injectable({ providedIn: 'root' })
export class ActivityMonitorService {
    // Observable sources
    private _monitorActivitySource = new Subject<boolean>();
    private _activityDetected = new Subject<boolean>();
    private _heartbeatSource = new Subject<boolean>();
    private _sessionWarningSource = new Subject<boolean>();
    private _sessionExtendedSource = new Subject<boolean>();
    private _sessionTimeoutSource = new Subject<boolean>();
    private _configChangedSource = new Subject<ConfigChangeRequest>();

    // Observable streams
    monitorActivity$: Observable<
        boolean
    > = this._monitorActivitySource.asObservable();
    activityDetected$: Observable<
        boolean
    > = this._activityDetected.asObservable();
    heartbeat$: Observable<boolean> = this._heartbeatSource.asObservable();
    sessionWarning$: Observable<
        boolean
    > = this._sessionWarningSource.asObservable();
    sessionExtended$: Observable<
        boolean
    > = this._sessionExtendedSource.asObservable();
    sessionTimeout$: Observable<
        boolean
    > = this._sessionTimeoutSource.asObservable();
    configChanged$: Observable<
        ConfigChangeRequest
    > = this._configChangedSource.asObservable();

    monitorActivity(isMonitoring: boolean): void {
        this._monitorActivitySource.next(isMonitoring);
    }

    activityDetected(isEventSource: boolean): void {
        this._activityDetected.next(isEventSource);
    }

    heartbeat(isEventSource: boolean): void {
        this._heartbeatSource.next(isEventSource);
    }

    sessionWarning(isEventSource: boolean): void {
        this._sessionWarningSource.next(isEventSource);
    }

    sessionExtended(isEventSource: boolean): void {
        this._sessionExtendedSource.next(isEventSource);
    }

    sessionTimeout(isEventSource: boolean): void {
        this._sessionTimeoutSource.next(isEventSource);
    }

    changeConfig(config: ConfigChangeRequest): void {
        this._configChangedSource.next(config);
    }
}
